<template>
	<div>
		<spinner v-if="report.loading" class="spinner"/>
		<button v-if="!report.loading && report.data" @click="handleCloseEvent" class="back mobile btn btn-small btn-round">Back</button>
		<health-report v-if="!report.loading && report.data" v-model="report.data" :user_uid="user_uid" :watch_id="watch_id" @closeEvent="handleCloseEvent"/>
		<p v-if="!report.loading && !report.data">Oops! Something went wrong.</p>
	</div>
</template>

<script>
import HealthReport from './HealthReport'
export default {
	components: {
		HealthReport
	},
	props: [
		'user_uid',
		'watch_id',
		'report_id',
		'value'
	],
	data () {
		return {
			report: {
				loading: false,
				error: null,
				data: null
			}
		}
	},
	watch: {
		'$route' (to, from) {
			if (to.fullPath !== from.fullPath) {
				this.getReport()
			}
		}
	},
	methods: {
		handleCloseEvent () {
			this.$emit('input', null)
			this.$router.push({ name: 'WatchHealthReports', params: { user_uid: this.user_uid, watch_id: this.watch_id } })
		},
		getReport () {
			this.report.loading = true
			this.$api.healthreports.get(this, this.user_uid, this.watch_id, this.report_id).then(response => {
				this.$log.info('watch healthreports', 'healthreports.get OK', response)()
				this.report.data = response.body
				this.$emit('input', this.report.data)
			}).catch(error => {
				this.$log.error('watch healthreports', 'healthreports.get ERROR', error)()
				this.report.error = error
			}).finally(() => {
				this.report.loading = false
			})
		}
	},
	mounted () {
		this.getReport()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/healthreports/HealthReportsView.vue